import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterLink } from '@angular/router';
import { NgbOffcanvas, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css'],
  imports: [CommonModule, RouterLink, NgbDropdownModule]
})
export class NavbarComponent {

  public menuMobileOpened: boolean = false;

  constructor(private ngbOffCanvas: NgbOffcanvas) {}

  public openSideMenu(content: any) {
    this.menuMobileOpened = !this.menuMobileOpened;
    this.ngbOffCanvas.open(content, { panelClass: 'menu-mobile-offcanvas-panel' }).result.then(
      (result) => { },
      (reason) => { this.menuMobileOpened = !this.menuMobileOpened; }
    );
  }
}
